import React from 'react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  const whatsappUrl = 'https://wa.me/5492995192151?text=%C2%A1Hola!%20Vi%20la%20web%20y%20quiero%20reservar%20un%20turno';
  return <section className="relative py-32 bg-night-900 z-20 border-t border-gold/20" data-id="element-11">
      {/* Subtle background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gold/5 rounded-full blur-[100px] pointer-events-none" data-id="element-12" />

      <div className="max-w-4xl mx-auto px-6 text-center relative z-10" data-id="element-13">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-14">
          <h2 className="font-serif text-5xl md:text-7xl text-white mb-8" data-id="element-15">
            ¿Listo para tu{' '}
            <span className="text-gold italic" data-id="element-16">transformación?</span>
          </h2>
          <p className="font-sans text-lg text-pearl/70 mb-12 max-w-2xl mx-auto" data-id="element-17">
            Da el primer paso hacia la sonrisa que siempre has deseado. Agenda
            una evaluación privada con nuestros especialistas.
          </p>

          <motion.a href={whatsappUrl} target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="inline-block bg-gold text-night-900 px-10 py-5 rounded-sm font-semibold text-base md:text-lg uppercase tracking-widest hover:bg-gold-light transition-colors shadow-[0_0_30px_rgba(212,175,55,0.4)]" data-id="element-18">
            Reservar Sesión VIP
          </motion.a>
        </motion.div>
      </div>
    </section>;
}